import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { PostalballotService } from 'src/app/services/postalballot.service';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../alert/alert.component';
declare var $: any;

@Component({
  selector: 'app-postalballotlist',
  templateUrl: './postalballotlist.component.html',
  styleUrls: ['./postalballotlist.component.css']
})
export class PostalballotlistComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfMasterDirector: DataTables.Settings = {};
  dtOptionsOfRegisterDirector: DataTables.Settings = {};
  registerDirectorList: any[];
  deletebankdetails: any;
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerMasterDirector: Subject<any> = new Subject();
  dtTriggerRegisterDirector: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  futureToDate: NgbDateStruct;
  futureFromDate: NgbDateStruct;
  currentURL: any;
  response: boolean;
  nameOfShareholder: any;
  deletePostalBallotId: any;
  editPostalBallotId: any;
  dateofReceipt: any;
  dateofReceiptTo: any;
  isSearchDivVisible = false;

  constructor(private postalballot: PostalballotService, private router: Router, private alert: AlertComponent,
    private activatedRoute: ActivatedRoute
  ) {
    this.response = false;
  }
  ngOnInit() {
    this.environmentSettings = environment;

    this.getRegisterDirectorList();

    this.dtOptionsOfRegisterDirector = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [5] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Postal Ballot',
          title: 'Postal Ballot',
          extend: 'excel',
          exportOptions: {
            columns: [0, 2, 3, 4],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }
        }
      ]
    };
  }
  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['postalballot','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  getRegisterDirectorList() {
    this.registerDirectorList = [];
    this.postalballot.getRegisterDirector({ isSearch: false }).subscribe(registerList => {
      $("#masterpostalballotlistTable").DataTable().destroy();
      this.registerDirectorList = registerList.data;
      this.dtTriggerRegisterDirector.next();
      // setTimeout(() => {
      //   this.dtTriggerRegisterDirector.next();
      // }, 200);
    });
  }

  confirmDelete(id) {
    this.deletePostalBallotId = id;
    $("#deleteConfirm").modal('toggle');
  }

  deletepostalballotdetail() {
    this.postalballot.removepostalballotdetails(this.deletePostalBallotId).subscribe(response => {
      if (response.status == 0) {
        $("#deleteConfirm").modal('toggle');
        $("#masterpostalballotlistTable").DataTable().destroy();
        this.alert.success(response.message);
        this.getRegisterDirectorList();
      } else {
        this.alert.error(response.message);
      }
    });

  }
  editpostalballot(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['postalballot','edit',_id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['postalballot/edit/', _id]);
  }

  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateofReceipt,
      toDate: this.dateofReceiptTo,
      name: this.nameOfShareholder
    }
    this.postalballot.generatePostalballotDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        console.log('before function call')
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);

      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.postalballot.downloadPostalballotFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.postalballot.downloadPostalballotPdfFile(id, 'Multi');
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  doAdvSearch() {
    this.response = true;
    var searchParam =
    {
      "nameOfShareholder": this.nameOfShareholder,
      "dateofReceipt": this.setDate(this.dateofReceipt),
      "dateofReceiptTo": this.setDate(this.dateofReceiptTo),
      'isSearch': true,
    };
    this.registerDirectorList = [];
    $("#masterpostalballotlistTable").DataTable().destroy();
    this.postalballot.getRegisterDirector(searchParam).subscribe(registerList => {
      this.response = false;
      this.registerDirectorList = registerList.data;
      this.dtTriggerRegisterDirector.next();
    });
  }
  clearAdvSearch() {
    this.nameOfShareholder = '';
    this.dateofReceipt = undefined;
    this.dateofReceiptTo = undefined;
    $("#masterpostalballotlistTable").DataTable().destroy();
    this.getRegisterDirectorList();

  }

}